<!-- https://stackoverflow.com/a/63665828 -->

<template>
  <Teleport :to="to" v-if="isMounted"><slot></slot></Teleport>
</template>

<script setup lang="ts">
import { ref, onMounted, nextTick } from 'vue';

defineProps<{ to: string }>();

const isMounted = ref(false);

onMounted(() => {
  nextTick(() => {
    isMounted.value = true;
  });
});
</script>
